import React from "react";
import { ref, deleteObject } from "firebase/storage";
import { storage } from "../../../../firebase";
import { Button } from "../../../../design/button";
import { TrashIcon } from "@heroicons/react/16/solid";
import { useCase } from "../../../../contexts/CaseContext";
import { useDeleteAlert } from "../../../../contexts/DeleteAlertProvider";
import { ClientFile } from "@visitproof/types";

type File = ClientFile;

interface DeleteFileButtonProps {
  caseId: string;
  file: File;
}

const DeleteCaseFileButton: React.FC<DeleteFileButtonProps> = ({
  caseId,
  file,
}) => {
  const { deleteFileFromCase } = useCase();
  const { openAlert } = useDeleteAlert();

  const handleDelete = async (id: string) => {
    const fileRef = ref(storage, file.path);
    await deleteObject(fileRef);
    await deleteFileFromCase(caseId, id);
  };

  const handleClick = () => {
    openAlert(
      file,
      {
        displayName: "file",
        onDelete: handleDelete,
        getId: (entity) => entity.id,
      }
    );
  };

  return (
    <Button type="button" color="red" onClick={handleClick}>
      <TrashIcon className="w-5 h-5" aria-hidden="true" />
    </Button>
  );
};

export default DeleteCaseFileButton;
